import React, { useEffect, useState } from "react";
import { Routes } from "../../constants";
import { Link } from "react-router-dom";
import CreateFaq from "./CreateFaq";
import { injectModels } from "../../redux/injectModels";
import ReactPaginate from "react-paginate";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const Faq = (props) => {
  const role = localStorage.getItem("userRole");
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [refreshLoader, setRefreshLoader] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  let paginatedData = [];
  try {
    if (Array.isArray(filteredData)) {
      paginatedData = filteredData.slice(offset, offset + rowsPerPage);
    } else {
      throw new Error("filteredData is not an array");
    }
  } catch (exception) {
    paginatedData = [];
    console.log(exception);
  }
  useEffect(() => {
    getFaq();
  }, [props.admin.loadingFaq]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (selected === pageCount - 1 || pageCount === 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };
  const getFaq = async () => {
    try {
      setRefreshLoader(true);
      const response = await props.admin.getAllFaq();
      props.application.setLoading(true);
      if (response.success) {
        setFilteredData(response.audio_sessions);
        props.application.setLoading(false);
        setRefreshLoader(false);
      } else {
        toast.error("Failed to fetch data", {
          position: toast.POSITION.TOP_CENTER,
        });
        props.application.setLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      props.application.setLoading(false);
      console.error("Error occured :", error);
    }
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageClassName={"page-item"}
          pageCount={pageCount}
          pageRangeDisplayed={0}
          marginPagesDisplayed={2}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          breakLabel="..."
          previousLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillLeftCircle />
            </IconContext.Provider>
          }
          nextLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillRightCircle />
            </IconContext.Provider>
          }
          renderOnZeroPageCount={null}
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };

  const formatDateTime = (apiTime) => {
    const date = new Date(apiTime);
    // Extract date components
    const day = String(date.getDate()).padStart(2, "0"); // Day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-indexed) with leading zero
    const year = date.getFullYear();
    // Extract time components
    const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Leading zero for minutes
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Leading zero for seconds
    const ampm = date.getHours() >= 12 ? "PM" : "AM"; // AM/PM
    // Combine date and time in desired format
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  const handleDeleteSession = async (id) => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          props.application.setLoading(true);
          const res = await props.admin.deleteFaq(id);
          if (res.success === true) {
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            getFaq();
            props.application.setLoading(false);
          } else {
            props.application.setLoading(false);
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        } catch (error) {
          console.log(error);
          props.application.setLoading(false);
          toast.dismiss();
          toast.success("Something went wrong!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    });
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle mb-3">
        <h1>Audio Mangement</h1>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={Routes.DASHBOARD}>Home</Link>
            </li>
            <li className="breadcrumb-item active">Audio Mangement</li>
          </ol>
        </nav>
      </div>
      <section className="section dashboard">
        <div className="row">
          <div className="col-12">
            <div className="card recent-sales overflow-auto">
              <div className="card-body p-3">
                <div className="data-se">
                  <div className="d-flex justify-content-between">
                    <div>
                      <a
                        href="#"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#largeModal"
                      >
                        Create Document
                      </a>
                      {"   "}
                      <button className="btn btn-primary" onClick={getFaq}>
                        {" "}
                        {refreshLoader ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span class="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <i class="fa-solid fa-rotate-right"></i>
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="tab-content pt-2" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {role === "admin" && <th>User Name</th>}
                            <th>Title</th>
                            <th>Type</th>
                            <th>Date</th>
                            <th>Duration</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedData && paginatedData.length > 0 ? (
                            paginatedData.map((item) => (
                              <tr key={item.id}>
                                {role === "admin" && <td>{item.username}</td>}
                                <td>{item.title}</td>
                                <td>
                                  {item.type === "faq"
                                    ? "Faq"
                                    : item.type === "normaltext"
                                    ? "SOP Creation"
                                    : item.type === "script"
                                    ? "Script"
                                    : ""}
                                </td>
                                <td>{formatDateTime(item.start_time)}</td>
                                <td>{item.duration}</td>
                                <td>
                                  {item.status === "running" ? (
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-outline-primary"
                                    >
                                      Processing...
                                    </button>
                                  ) : item.status === "completed" ? (
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-outline-success"
                                    >
                                      Done
                                    </button>
                                  ) : item.status === "incompleted" ? (
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-outline-danger"
                                    >
                                      Incompleted
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td>
                                  {item.status === "running" ||
                                  item.status === "incompleted" ? (
                                    <button
                                      className="btn btn-sm prompt_notty"
                                      type="button"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="bottom"
                                      title={
                                        item.status === "running" &&
                                        "Audio uploaded successfully! Please click refresh button to check its processing status."
                                      }
                                    >
                                      Prompt Data
                                    </button>
                                  ) : (
                                    <a
                                      className="btn btn-dark btn-sm"
                                      href={item.audio_prompt_file}
                                      download
                                    >
                                      Prompt Data
                                    </a>
                                  )}{" "}
                                  {item.status === "running" ||
                                  item.status === "incompleted" ? (
                                    <button
                                      className="btn btn-sm prompt_notty"
                                      type="button"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="bottom"
                                      title={
                                        item.status === "running" &&
                                        "Audio uploaded successfully! Please click refresh button to check its processing status."
                                      }
                                    >
                                      Download
                                    </button>
                                  ) : (
                                    <a
                                      className="btn btn-primary btn-sm"
                                      href={item.audio_document_file}
                                      download
                                    >
                                      <i className="fa-solid fa-download"></i>
                                    </a>
                                  )}{" "}
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleDeleteSession(item.id)}
                                  >
                                    <i className="bi bi-trash-fill"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No results found!
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {
                        <div className="table-footer">
                          <strong>Total Count: {filteredData.length}</strong>
                          {renderPagination()}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CreateFaq />
    </main>
  );
};

export default injectModels(["admin", "application"])(Faq);
